export default __webpack_public_path__ + "static/media/lock.ed05dd76.png";